module.exports = __webpack_public_path__ + "static/media/9DESA32.3eca6205.jpg";